module.exports = {
    apiKey: "AIzaSyBeU-7QA0371Ek2yH-LhJfdHPH75GApgCA",
    authDomain: "taiwantrip-v7.firebaseapp.com",
    projectId: "taiwantrip-v7",
    storageBucket: "taiwantrip-v7.firebasestorage.app",
    messagingSenderId: "286485315056",
    appId: "1:286485315056:web:53e4ae3a8cf7367423b135",
    measurementId: "G-C6YR93SZCY"
};